export enum AccountRestrictionAction {
  Listing = 5,
  Selling = 6,
}
